<main>
    <section class="taxa-mix">
        <hr>
        <app-header-title title="Taxa mix" subTitle="Deseja calcular a taxa mix?" classTitle="taxa-mix__title"></app-header-title>

        <div class="taxa-mix__radio-box">
          <mat-radio-group [disabled]="taxaMixForm.controls.visualizando.value === true || taxaMixForm.controls.alterando.value === true" 
          [formControl]="taxaMixRadioControl" 
          [ngClass]="{'blockMask': taxaMixForm.controls.visualizando.disabled === true || taxaMixForm.controls.alterando.disabled === true }" 
          (change)="changeTaxaMix()">
            <mat-radio-button id="botao-taxamix-falso" [value]="false">Não</mat-radio-button>
            <mat-radio-button id="botao-taxamix-verdadeiro" [value]="true">Sim</mat-radio-button>
          </mat-radio-group>
        </div>

        <form class="taxa-mix__container" [formGroup]="taxaMixForm" *ngIf="taxaMixRadioControl.value">

            <div class="container__group">

                <div class="group__form">
                    <mat-label class="form__title">Taxa</mat-label>
                    <mat-form-field appearance="outline" class="form__field">
                        <input matInput placeholder="0,00 %" formControlName="taxa" mask="percent" suffix="%" [ngClass]="{'blockMask': taxaMixForm.controls.taxa.disabled === true, 'field__input': taxaMixForm.controls.taxa.disabled === false }">
                    </mat-form-field>
                </div>

                <div class="group__form">
                    <mat-label class="form__title">IS</mat-label>
                    <mat-form-field appearance="outline" class="form__field">
                        <input matInput placeholder="R$ 0,00" formControlName="importanciaSegurada" currencyMask [ngClass]="{'blockMask': taxaMixForm.controls.importanciaSegurada.disabled === true, 'field__input': taxaMixForm.controls.importanciaSegurada.disabled === false }">
                    </mat-form-field>
                </div>

                <div class="group__form">
                    <mat-label class="form__title">Início Vigência</mat-label>
                    <mat-form-field appearance="outline" class="form__field">
                        <input matInput type="date" placeholder="dd/mm/yy" formControlName="inicioVigencia" [ngClass]="{'blockMask': taxaMixForm.controls.inicioVigencia.disabled === true, 'field__input': taxaMixForm.controls.inicioVigencia.disabled === false }">
                    </mat-form-field>
                </div>

                <div class="group__form">
                    <mat-label class="form__title">Término Vigência</mat-label>
                    <mat-form-field appearance="outline" class="form__field">
                        <input matInput type="date" placeholder="dd/mm/yy" formControlName="terminoVigencia" max="2100-12-31" [ngClass]="{'blockMask': taxaMixForm.controls.terminoVigencia.disabled === true, 'field__input': taxaMixForm.controls.terminoVigencia.disabled === false }">
                    </mat-form-field>
                </div>

                <div class="group__form">
                    <mat-label class="form__title">Prêmio</mat-label>
                    <mat-form-field appearance="outline" class="form__field">
                        <input currencyMask matInput placeholder="R$ 0,00" formControlName="premio" [ngClass]="{'blockMask': taxaMixForm.controls.premio.disabled === true, 'field__input': taxaMixForm.controls.premio.disabled === false }">
                    </mat-form-field>
                </div>

                <div class="group__form">
                    <mat-label class="form__title">Comissão</mat-label>
                    <mat-form-field appearance="outline" class="form__field">
                        <input matInput placeholder="R$ 0,00" currencyMask formControlName="comissao" [ngClass]="{'blockMask': taxaMixForm.controls.comissao.disabled === true, 'field__input': taxaMixForm.controls.comissao.disabled === false }">
                    </mat-form-field>
                </div>

            </div>

            <hr>

            <app-header-title title="Parâmetros para simulação" subTitle="Simular taxa mix" classTitle="container__title"></app-header-title>

            <div class="container__group" >

                <div class="group__form">
                    <mat-label class="form__title">Tipo de taxa mix</mat-label>
                    <mat-form-field appearance="outline" class="form__field">
                        <mat-select placeholder="Selecione" formControlName="tipoDeTaxaMixId" [ngClass]="{'blockMask': taxaMixForm.controls.tipoDeTaxaMix.disabled === true }">
                            <mat-option *ngFor="let item of listaTipoDeTaxaMix" [value]="item.averageMixId" class="field__select">
                                {{item.name}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="taxaMixForm.controls.tipoDeTaxaMix.hasError('required')">
                        Tipo de taxa mix é <strong>obrigatório</strong>
                        </mat-error>
                    </mat-form-field>
                </div>

                <!-- <div class="group__form">
                    <mat-label class="form__title">Tipo de aplicação</mat-label>
                    <mat-form-field appearance="outline" class="form__field">
                        <mat-select placeholder="Selecione" formControlName="tipoDeAplicacao" [ngClass]="{'blockMask': taxaMixForm.controls.tipoDeAplicacao.disabled === true }">
                            <mat-option class="field__select" *ngFor="let item of listaTipoDeAplicacao" [value]="item.value">
                                {{item.viewValue}}
                            </mat-option>
                        </mat-select>
                        <mat-error *ngIf="taxaMixForm.controls.tipoDeAplicacao.hasError('required')">
                        Tipo de aplicação <strong>obrigatório</strong>
                        </mat-error>
                    </mat-form-field>
                </div> -->

                <div class="group__form">
                    <mat-label class="form__title">Percentual</mat-label>
                    <mat-form-field appearance="outline" class="form__field">
                        <input matInput placeholder="0%" currencyMask [options]="{ inputMode: 'NATURAL', prefix: '', suffix: '%' }" formControlName="percentual" suffix="%" [ngClass]="{'blockMask': taxaMixForm.controls.percentual.disabled === true, 'field__input': taxaMixForm.controls.percentual.disabled === false }">
                        <mat-error *ngIf="taxaMixForm.controls.percentual.hasError('required')">
                        Percentual é <strong>obrigatório</strong>
                        </mat-error>
                    </mat-form-field>
                </div>
            </div>

            <button mat-raised-button type="button" [disabled]="!taxaMixForm.valid || taxaMixForm.controls.visualizando.value === true" (click)="computeTaxaMix()" class="button">{{nomeBotaoTaxaMix}}</button>

            <div class="container__group--data" *ngIf="resultTaxaMixData.length">

                <hr>

                <app-header-title title="Resultados" classTitle="data__title"></app-header-title>

                <div class="group__data-group" *ngIf="resultTaxaMixData.length">
                    <div class="data-group__card">
                        <app-card-create [response]="resultTaxaMixCardOrTable"></app-card-create>
                    </div>

                    <div class="data-group__table">
                        <app-table-create [response]="resultTaxaMixCardOrTable"></app-table-create>
                    </div>
                </div>

                <div class="group__button-box">
                    <button mat-raised-button type="button" class="button" (click)="showModalComputeTaxaMix()" class="button" [disabled]="taxaMixForm.controls.visualizando.value === true" *ngIf="mostarBotaoEfetivar">EFETIVAR SIMULAÇÃO</button>
                </div>
            </div>
        </form>

        <hr>
    </section>
</main>
